import YaCounter from "../src/modules/analytics/ym";

if (!window.Turbo) {
	require("@hotwired/turbo");
}

import './_fetch.js'
import './_prefetch.js'
import './_submit.js'
import './_render.js'

document.addEventListener("turbo:before-fetch-response", (event) => {
	if (
		event.detail.fetchResponse?.response?.status === 404
		&& event.target?.tagName?.toLowerCase() === 'html'
	) {
		location.href = event.detail.fetchResponse?.response?.url;
		return false;
	}
});

window.onTurboRender = function (callback) {
	document.addEventListener("turbo:render", (event) => {
		if (event.target?.hasAttribute('data-turbo-preview') === true) return;
		callback();
	});
};

document.addEventListener("turbo:render", (event) => {
	event.target?.querySelector('#vg-nav-sidebar')?.classList.remove('open');
	event.target?.querySelector('body')?.classList.remove('vg-sidebar-open');
	event.target?.querySelector('.vg-nav-hamburger')?.classList.remove('vg-sidebar-active');

	event.target?.querySelector('header .header-wrapper')?.classList.remove('hide', 'scroll', 'fixed');

	setTimeout(() => {
		new YaCounter().hit();
	}, 1000);
});


document.addEventListener('DOMContentLoaded', () => {
	window.addEventListener('hashchange', () => {
		document.documentElement.dataset.hash = location.hash || '';
	});
});
